import { Component } from '@angular/core'

@Component({
  templateUrl: './jobs.component.html',
  styleUrls: ['./jobs.component.scss'],
})
export class JobsComponent {
  constructor() {}
}
